module.exports = __webpack_public_path__ + "img/bench.704a340b.svg";